import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IconButton, Button } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { hide } from 'layouts/actions'
import { billetFileUrlSelector } from '../selectors/billet'

export const SnackBillet = () => {

  const dispatch = useDispatch()
  const urlFile = useSelector(billetFileUrlSelector)

  const onClick = () => {
    const newWindow = window.open(urlFile, '_blank', 'noopener')
    if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
      // Se a nova aba n�o foi aberta devido a ADBlocker ou Outro Motivo, fazer o download diretamente
      const link = document.createElement('a')
      link.href = urlFile
      link.download = 'Boleto.pdf'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
    dispatch(hide())
  }

  return ([
    <Button key='clique-aqui' color='secondary' size='small' onClick={onClick}>
      CLIQUE AQUI!
    </Button>,
    <IconButton
      key='close'
      aria-label='close'
      color='inherit'
      onClick={() => dispatch(hide())}
    >
      <CloseIcon />
    </IconButton>,
  ])
}
